// NOTE: These handlers are intentionally kept separate from the ./utils.ts file to avoid including tinymce in
// consumers' main bundles. If moving these, PLEASE double check that tinymce is not ending up in consumers' main bundles

import { COLLAB_MODE_INTERACTIONS_TRACKING } from 'tinymce-plugins/hscopilotcollaboration/constants';
import { removeSpanResetStateAndRemoveSlash
// @ts-expect-error Untyped module
} from 'tinymce-plugins/hsautocomplete/utils';
import { trackInteraction } from '../utils/usageTracking';
function attachHandlerToCommands(commands, handlerFunc, commandType, sessionId) {
  // Take the command handler from the app and add some additional logic to it
  const onClick = (editorInEvent, command, ___commandType, isToolbarInteraction = false) => {
    additionalLogicForEveryCommandClick(editorInEvent, commandType);
    handlerFunc(editorInEvent, command, commandType);
    trackCommandSelection(editorInEvent, command, commandType, isToolbarInteraction, sessionId);
  };
  return commands.map(c => Object.assign({}, c, {
    onClick
  }));
}
export function getSlashCommandsWithHandler(slashCommands, commandHandler, sessionId) {
  return attachHandlerToCommands(slashCommands, commandHandler, 'slash', sessionId);
}
export function getHighlightCommandsWithHandler(slashCommands, commandHandler, sessionId) {
  return attachHandlerToCommands(slashCommands, commandHandler, 'highlight', sessionId);
}
function isImageSlashCommand(command) {
  // TODO: This ideally should be part of a union of some sort, but this works for now
  return command.id === 'generateimage';
}
function additionalLogicForEveryCommandClick(editor, commandType) {
  if (commandType === 'slash') {
    removeSpanResetStateAndRemoveSlash(editor);
  }
}
function trackCommandSelection(editor, command, commandType, isToolbarInteraction, sessionId) {
  var _ref, _command$commandId, _command$parameters;
  const isHighlightCommand = commandType === 'highlight';
  const highlightedText = editor.selection.getContent({
    format: 'text'
  });
  const commandName = isImageSlashCommand(command) ? command.labelKey : (_ref = (_command$commandId = command.commandId) !== null && _command$commandId !== void 0 ? _command$commandId : // @ts-expect-error accessing parameters when we probably shouldn't be
  command === null || command === void 0 || (_command$parameters = command.parameters) === null || _command$parameters === void 0 ? void 0 : _command$parameters.toneOfVoice) !== null && _ref !== void 0 ? _ref :
  // Should never hit this last case, but leaving as fallback
  command.labelKey;
  trackInteraction(editor, COLLAB_MODE_INTERACTIONS_TRACKING,
  // `action` - (will be added to the eventProperties below)
  'intent-selected', {
    interactionType: isToolbarInteraction ? 'toolbar-interaction' : 'inline-interaction',
    featureCategoryId: isHighlightCommand ? 'content_rewrite' : 'generate_text',
    sessionId,
    commandName,
    textUsed: isHighlightCommand ? highlightedText : undefined
    // inApp: supplied by tinyMCE magic
  });
}